import React, { useState, useEffect } from 'react';
import { MagnifyingGlass, MapPin, X } from '@phosphor-icons/react';

const RADIUS_OPTIONS = [10, 25, 50, 100];

const LocationSearch = ({ onSearch, userLocation, placeholder }) => {
  const [location, setLocation] = useState('');
  const [radius, setRadius] = useState(50);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (userLocation) setLocation(userLocation);
  }, [userLocation]);

  const handleSearch = () => {
    onSearch({ location, radius });
    setIsActive(true);
  };

  const handleClear = () => {
    setLocation('');
    setIsActive(false);
    onSearch({ location: '', radius: 0 });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="flex items-center gap-3 flex-wrap" data-testid="location-search-bar">
      <div className="flex items-center gap-2 flex-1 min-w-[240px] px-4 py-2.5 rounded-xl" style={{ background: 'var(--bg-elevated)', border: '1px solid var(--border-subtle)' }}>
        <MapPin size={18} weight="duotone" style={{ color: 'var(--gold)', flexShrink: 0 }} />
        <input
          data-testid="location-search-input"
          type="text"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder || 'City, state, or ZIP...'}
          className="flex-1 bg-transparent border-none outline-none text-sm"
          style={{ color: 'var(--text-primary)' }}
        />
        {isActive && (
          <button data-testid="location-search-clear" onClick={handleClear} className="p-0.5 rounded" style={{ color: 'var(--text-muted)' }}>
            <X size={14} />
          </button>
        )}
      </div>
      <select
        data-testid="radius-select"
        value={radius}
        onChange={(e) => {
          const r = parseInt(e.target.value);
          setRadius(r);
          if (location) onSearch({ location, radius: r });
        }}
        className="px-3 py-2.5 rounded-xl text-sm font-medium cursor-pointer"
        style={{ background: 'var(--bg-elevated)', border: '1px solid var(--border-subtle)', color: 'var(--text-primary)', appearance: 'auto' }}
      >
        {RADIUS_OPTIONS.map(r => (
          <option key={r} value={r}>{r} miles</option>
        ))}
      </select>
      <button
        data-testid="location-search-button"
        onClick={handleSearch}
        disabled={!location}
        className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all"
        style={{
          background: location ? 'linear-gradient(180deg, var(--gold), var(--gold-dark))' : 'var(--bg-elevated)',
          color: location ? '#1a1a1a' : 'var(--text-muted)',
          border: '1px solid transparent',
          cursor: location ? 'pointer' : 'default',
        }}
      >
        <MagnifyingGlass size={16} weight="bold" />
        Search
      </button>
    </div>
  );
};

export default LocationSearch;
